import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the gcIllustrationPage state domain
 */
const selectGcIllustrationPageDomain = state =>
  state.get('gcIllustrationPage', initialState);

/**
 * Other specific selectors
 */
const makeSelectLifeAssured = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('lifeAssured').toJS(),
  );

const makeSelectInitialLifeAssured = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('initialLifeAssured').toJS(),
  );

const makeSelectError = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('errorData').toJS(),
  );

const makeSelectConfig = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('gcConfig').toJS(),
  );

const makeSelectBiTableValues = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('biTableValues').toJS(),
  );

const makeSelectFiaCharge = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('fiaData').toJS(),
  );

const makeSelectProductConfig = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('productConfig').toJS(),
  );

const makeSelectQuoteId = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('quoteId'),
  );

const makeSelectApplicationId = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('applicationId'),
  );

const makeSelectBiPdf = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('benefitIllustrationPdf'),
  );

const makeSelectStatus = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('status'),
  );

const makeSelectReferenceNumber = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('referenceNumber'),
  );

const makeSelectCloneStatus = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('successClone'),
  );

const makeSelectemailSentStatus = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('emailSent'),
  );

const makeSelectEmailErrorMessage = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('emailErrorMessage'),
  );

const makeSelectFormInput = () =>
  createSelector(selectGcIllustrationPageDomain, substate =>
    substate.get('input').toJS(),
  );

export {
  selectGcIllustrationPageDomain,
  makeSelectLifeAssured,
  makeSelectProductConfig,
  makeSelectFiaCharge,
  makeSelectConfig,
  makeSelectError,
  makeSelectQuoteId,
  makeSelectApplicationId,
  makeSelectBiPdf,
  makeSelectStatus,
  makeSelectReferenceNumber,
  makeSelectInitialLifeAssured,
  makeSelectBiTableValues,
  makeSelectCloneStatus,
  makeSelectemailSentStatus,
  makeSelectEmailErrorMessage,
  makeSelectFormInput,
};
